export default __webpack_public_path__ + "static/media/service-2.ee601c7c.jpg";